import React from 'react';
import { CnLayoutCol as UICnLayoutCol } from '@cainiaofe/cn-ui';
const CnLayoutCol = (props) => {
    const { children } = props || {};
    return <UICnLayoutCol>{children}</UICnLayoutCol>;
};
CnLayoutCol.displayName = 'CnLayoutCol';
export default CnLayoutCol;
export { CnLayoutCol };
